module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAAMFJREFUKFNjZMABCgoKDIBS+4G4cMKECQuwKWPEJgjVeAAoxw+VT8RmAIZmJBsF0AwOBBqwAVkMm+YJQAX5WFw0Eai5AEUz0KYAJMUg/10AKQCKO0D97AgUA3kBJAYKh36oARMZgQIfoByQpgIiNINcBjLkP0jzfyDjIFATyCY4wGYzTBIoB3KJ/ahmtMiFRuMBYGDCYgSsAj3AHgDFFmBJGLiEEoASCqDQxpWiCJk1EZw8gQYogEwipBpJ/gHQKw8AAuaE+POfgKQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/download.png
// module id = tibv
// module chunks = 0